import { useEffect, useState } from "react";
import { getFiscalReport } from "../../utils/dataFetch";

export default function FiscalReport() {
    const [fiscal, setFiscal] = useState([]);
    const [dataError, setDataError] = useState("");

    useEffect(() => {
        const fetchFiscalReport = async () => {
            try {
                const result = await getFiscalReport();
                setFiscal(result);
            } catch (error) {
                setDataError("Помилка завантаження даних!");
            }
        };

        fetchFiscalReport();
    }, []);

    return fiscal.length === 0 ? null : (
        <div className="col-12 dashboard--item">
            <div className="dashboard--item--container p-3 h-100">
                <h5 className="text-center fw-bold">Офіційні продажі</h5>
                {dataError && <div className="alert alert-danger m-auto rounded-5">{dataError}</div>}
                {!dataError && (
                    <div className="mt-3">
                        <div className="table-responsive rounded-4">
                            <table className="table table-sm table-striped table-light table-hover m-0">
                                <thead>
                                    <tr>
                                        <th className="text-center align-middle" scope="col">
                                            Назва
                                        </th>
                                        <th className="text-center align-middle" scope="col">
                                            За сьогодні
                                        </th>
                                        <th className="text-center align-middle" scope="col">
                                            З початку року
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {fiscal.map((item, index) => (
                                        <tr key={index}>
                                            <th className="text-center align-middle" scope="row">
                                                {item.name}
                                            </th>
                                            <td className="text-center align-middle">
                                                <span className={`px-2 rounded-4 ${parseFloat(item.dayTotals) < 0 && "bg-danger-subtle"}`}>
                                                    {item.dayTotals ? parseFloat(item.dayTotals).toFixed(2) : "Зміну не відкрито"}
                                                </span>
                                            </td>
                                            <td className="text-center align-middle">
                                                <span className={`px-2 rounded-4 ${parseFloat(item.yearTotals) < 0 && "bg-danger-subtle"}`}>
                                                    {parseFloat(item.yearTotals).toFixed(2)}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
